<template>
  <div>
    <div class="page f-pr">
      <img src="../assets/bg2-new.png" alt="">

      <div class="page2-info">

        <div class="flex row">
          <div class="left">
            姓名：
          </div>
          <div class="right">
            <input type="text" v-model="userInfo.realname" placeholder="请输入">
          </div>
        </div>
        <div class="flex row">
          <div class="left">
            价值同盟团名：
          </div>
          <div class="right">
            <input type="text" v-model="userInfo.slogan" placeholder="请输入">
          </div>
        </div>
        <div class="flex row">
          <div class="left">
            菜地编号：
          </div>
          <div class="right">
            <input v-model="userInfo.userNo" type="text" placeholder="请输入" maxlength="6">
            <div class="p">
              <!-- （寄语字数控制在6个字以内） -->
            </div>
          </div>
        </div>
      </div>

      <div class="btn-submit fcc" >
        <img src="@/assets/btn-submit.png" alt="" @click="submit">
      </div>


      <van-overlay :show="showLoading">
        <div class="fcc-h " style="height: 100vh;">
          <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
        </div>
      </van-overlay>

      <van-overlay :show="showPopSign" z-index="999" @click="showPopSign = !showPopSign" @touchstart="handleTouchStart">
        <div class="fcc-h gz-pop" style="height: 100vh; overflow: auto;">
          <div class="f-pr gz-pop-con fcc-h" @click.stop=''>
            <div class="fcc">
              <!-- <img src="../assets/yqjzb.png" alt="" class="img1"> -->
            </div>



            <!-- 盖章区域 -->
            <div class="gz-area fcc ">
              <img src="../assets/gzq.png" alt="">
            </div>


            <div class="gz-tips fcc">
              <img src="../assets/zcgz.png" alt="">
            </div>
            <div class="fix-btn" @click="showPopSign = !showPopSign">

              <van-icon name="cross" size="36" color="#fff" />
            </div>
          </div>
        </div>
      </van-overlay>
      <div style="position:fixed;left: 110%;top: 110%;width: 0;height: 0;overflow: hidden">
        <audio id="audioID" ref="audio" class="aud">
          <source src="https://park.warnny.com/duang.mp3" type="audio/mp3" />
        </audio>
      </div>


    </div>
  </div>
</template>

<script>

import { login, checkTask } from "@/api/api";
import { check } from "@/utils/check"
import CryptoJS from 'crypto-js'

export default {


  data() {
    return {
      showLoading: false,
      uid:"",
      showPopSign: false,
      userInfo:{
        realname:'',
        userNo:'',
        slogan:''
      }
    }
  },

  async mounted() {
    this.uid = window.localStorage.getItem('openId')
    if (this.uid && this.uid != 'null' && this.uid != 'undefinded') {
      this.loginFun(this.uid)
    } else {
      return
    }
  },
  methods:{
    submit(){
      if(!this.userInfo.realname){
        this.$toast("请输入姓名")
        return
      }
      if(!this.userInfo.userNo){
        this.$toast("请输入菜地编号")
        return
      }
      if(!this.userInfo.slogan){
        this.$toast("请输入价值同盟团名")
        return
      }
      if(this.showLoading){
        return
      }
      this.showLoading = true
      let self = this
      login({
        username: self.userInfo.username,
        realname: self.userInfo.realname,
        userNo: self.userInfo.userNo,
        slogan: self.userInfo.slogan,
      }).then(res => {
        console.log("login res: ", res)
        self.showLoading = false
        if (res.status != 200) {
          this.$toast(res.msg)
          return
        } else {
          window.localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
          self.userInfo = res.data.userInfo
          self.openPopup()
          // self.$router.push({ path: '/index3' })
        }
      }).finally(f => {
        self.showLoading = false
      })
    },
    loginFun(uid) {
      let self = this
      self.showLoading = true
      login({ username: uid }).then(res => {
        console.log("login res: ", res)
        if (res.status != 200) {
          this.$toast(res.msg)
          return
        } else {
          window.localStorage.setItem('uid', res.data.userInfo.username)
          window.localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
          self.uid = res.data.userInfo.username
          self.userInfo = res.data.userInfo
          if(self.userInfo.realname && self.userInfo.userNo && self.userInfo.slogan && self.userInfo.isGet==1){
            self.$router.push({ path: '/index3' })
          }
        }
      }).finally(f => {
        self.showLoading = false
      })
    },
    openPopup() {
      this.showPopSign = true
    },
    async handleTouchStart(event) {
      let that = this;
      if (event.touches.length != 4) {
        return
      }
      if (this.gaizhangCount > 5) {
        that.$toast("盖章失败次数达5次，请输入口令")
        return
      }
      let timestamp = new Date().getTime();
      // 获取触摸点的坐标
      let touchArr = []
      for (let i = 0; i < event.touches.length; i++) {
        var touchX = event.touches[i].clientX;
        var touchY = event.touches[i].clientY;
        let touchItem = [touchX, touchY]
        touchArr.push(touchItem)
      }
      let scope = check(touchArr)
      if (!scope) {
        // that.$toast("打卡失败，请重试")
        return
      }
      if (scope) {
        if (this.checking) {
          return
        }
        this.checking = true
        //时间戳
        let request = {
          taskName: that.userInfo.username,
          timestamp: timestamp,
          userId: that.userInfo.username
        }
        console.log("request:", request)
        let md5Result = CryptoJS.MD5(request.taskName + request.timestamp + request.userId).toString();
        console.log("request:", md5Result)
        request.sign = md5Result
        request.method = 1
        checkTask(request).then(res => {
          if (res && res.msg) {
            this.$toast(res.msg)
            this.checking = false
          } else if (res) {
            that.showPopSign = false
            that.$toast("打卡成功")
            document.querySelector('audio').play()
            document.getElementById("audioID").play()
            that.checking = false
            setTimeout(function(){
              that.$router.push({ path: '/index3' })
            }, 2000)
          } else {
            that.$toast("打卡失败，请重试")
            that.checking = false
          }
        })
      }
    },
  }

}

</script>
<style scoped lang="less">
.page {
  display: block;

  min-height: 100vh;
  background: #D6F9D8;
  background-size: 100% auto;
  // background-size: cover;
  position: relative;

  >img {
    display: block;
    width: 100%;
  }
}


.btn-submit{
  width: 184px;
  height: 184px;
  position: absolute;
  top: 1013px;
  left: 50%;
  transform: translateX(-50%);
  img{
    display: block;
    width: 100%;
  }
}


.page2-info {
  position: absolute;
  left: 102px;
  right: 94px;
  top: 672px - 16px;

  font-weight: 300;
  font-size: 26px;
  color: #000000;
  line-height: 55px;

  .left {
    width: 228px;
    width: 228px;
    font-weight: 400;
    font-size: 32px;
    color: #000000;
    line-height: 46px;
    text-align: right;
  }
  .row{
    margin-bottom: 30px;
  }
  .right{
    width: 288px;
    input{
      width: 100%;
      height: 46px;
      line-height:46px;
      padding:0 10px;
      font-size: 30px;
      color: #000;
      border: none;
    }
  }
  .p {
    
    text-align: center;
    font-size: 20px;
    font-weight: 300;
   
    color: #000000;
    line-height: 35px;
    white-space: nowrap;
  }
}

.gz {
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 50px;
  position: absolute;
  left: 93px;
  top: 880px;
  height: 245px;
  padding-top: 52px;
  background: url(../assets/z.png) 11px 0 no-repeat;
  background-size: 245px 245px;


}
</style>